import {
    Component,
    Input,
    OnInit} from "@angular/core";
import { TreeNode } from "primeng/api";
import { throwIfEmpty } from "rxjs/operators";
import { AccountService } from "../service/account.service";

@Component({
    selector: "dimension-picker-tree",
    templateUrl: "./dimension-picker-tree.component.html"
})
export class DimensionPickerTreeComponent implements OnInit {
    constructor(private accountService: AccountService) {}

    @Input() label: string;
    @Input() dimension: TreeNode;
    @Input() reportId: number;
    @Input() accountsForTable: TreeNode[];

    selected: TreeNode;
    tableColumns: any[];
    dimensionPickerVisible: boolean = false;
    accountsForTableExist: boolean;

    ngOnInit() {
        this.tableColumns = [{ field: "name", header: "Name", width: "100%" }];
    }

    okClick() {
        this.dimension = this.selected;
    }

    clear() {
        this.dimension = null;
    }

    showDialog() {
        this.dimensionPickerVisible = true;
    }
}
